import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './frontend/components/Navbar';
import ScrollToTop from './frontend/components/ScrollToTop';
import ScrollToTopButton from './frontend/components/ScrollToTopButton';
import FloatingButton from './frontend/components/FloatingButton';
import InspectionModal from './frontend/components/InspectionModal';

// Pages
import Home from './frontend/pages/Home';
import About from './frontend/pages/About';
import ServicesPage from './frontend/pages/ServicesPage';
import Pest from './frontend/pages/Pest';
import Contact from './frontend/pages/Contact';
import Login from './frontend/pages/Login';
import Footer from './frontend/components/Footer';


function App() {
  return (

    <Router>

      <Navbar />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/pest" element={<Pest />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login/>} />
      </Routes>
      <Footer />
      <FloatingButton />
      <InspectionModal />
      <ScrollToTopButton />

    </Router>

  );
}

export default App;